import { render, staticRenderFns } from "./myGodList.vue?vue&type=template&id=3d09fe72&scoped=true&"
import script from "./myGodList.vue?vue&type=script&lang=js&"
export * from "./myGodList.vue?vue&type=script&lang=js&"
import style0 from "./myGodList.vue?vue&type=style&index=0&id=3d09fe72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09fe72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d09fe72')) {
      api.createRecord('3d09fe72', component.options)
    } else {
      api.reload('3d09fe72', component.options)
    }
    module.hot.accept("./myGodList.vue?vue&type=template&id=3d09fe72&scoped=true&", function () {
      api.rerender('3d09fe72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/god/myGodList.vue"
export default component.exports